(function () {
	'use strict';

    angular.module("imApp").factory("consignmentPlansConsignmentContentService", ['$ihttp', function ($ihttp) {
		let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1692,
                    parameters: parms || {}
                });
            },
            listContents: function (parms) {
                return $ihttp.post({
                    method: 1681,
                    parameters: parms || {}
                });
            },
            listLabours: function (parms) {
                return $ihttp.post({
                    method: 1790,
                    parameters: parms || {}
                });
            },
            completeDelivery: function (mergeObj) {
                return $ihttp.post({
                    method: 1712,
                    parameters: mergeObj
                });
            },
            temporaryQuantities: function (items) {
                return $ihttp.post({
                    method: 2174,
                    parameters: items
                });
            },
            switchModus: function (parms) {
                return $ihttp.post({
					method: 2381,
                    parameters: parms
                });
            },
            printReport: function (setting) {
                return $ihttp.post({
                    method: 3144,
                    parameters: setting
                });
            }
		};

		return service;
	}]);
})();
